import useFormStateWithErrors from "shared/utils/useFormStateWithErrors";

type GroupEditor = {
  name: string;
  classifier: { id: number; name: string } | null;
};

const defaultValue: GroupEditor = {
  name: "",
  classifier: null,
};

const errors: Record<keyof GroupEditor, string> = {
  name: "",
  classifier: "",
};

export const useGroupEditorState = () => {
  return useFormStateWithErrors<GroupEditor>(defaultValue, errors);
};
